/* import __COLOCATED_TEMPLATE__ from './search-box.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isNone } from '@ember/utils';
import { restartableTask, timeout } from 'ember-concurrency';
import { service } from '@ember/service';
import { guidFor } from '@ember/object/internals';
const DEBOUNCE_TIMEOUT = 250;
let SearchBox = (_class = class SearchBox extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "value", _descriptor2, this);
    _defineProperty(this, "searchTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.moveFocus();
        yield timeout(DEBOUNCE_TIMEOUT);
        yield this.args.search(this.value);
      }
    }), null, "searchTask", "restartable"));
  }
  get searchBoxId() {
    return `search-box-${guidFor(this)}`;
  }
  get searchBoxInputElement() {
    return document.getElementById(this.searchBoxId).querySelector('input');
  }
  get liveSearch() {
    return isNone(this.args.liveSearch) ? true : this.args.liveSearch;
  }
  get placeholder() {
    return this.args.placeholder ?? this.intl.t('general.search');
  }
  get maxlength() {
    return this.args.maxlength ?? '6000';
  }
  update(event) {
    this.value = event.target.value;
    if (this.liveSearch) {
      this.searchTask.perform();
    }
  }
  clear() {
    this.value = '';
    if (this.args.clear) {
      this.args.clear();
    }
  }
  moveFocus() {
    // place focus into the search box when search icon is clicked
    this?.searchBoxInputElement?.focus();
  }
  keyUp({
    key
  }) {
    switch (key) {
      case 'Enter':
        this.searchTask.perform();
        break;
      case 'Escape':
        this.clear();
        break;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyUp"), _class.prototype), _class);
export { SearchBox as default };